import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import '../modal.scss';
import ProjectCreate from "./ProjectCreate";
import ProjectSearch from "./ProjectSearch";
import ProjectTable from "./ProjectTable";
import AssignPhoneNumbers from "./AssignPhoneNumbers";
import {Slide, toast} from 'react-toastify'

function Projects({loggedInUser}) {
    const [projects, setProjects] = useState([]);

    const [showCreateEditModal, setShowCreateEditModal] = useState(false);
    const [editingProject, setEditingProject] = useState(null);

    const [showAssignPhoneNumberModal, setShowAssignPhoneNumberModal] = useState(false);
    const [assigningPhoneNumberProject, setAssigningPhoneNumberProject] = useState(null);

    const baseUrl = `/tenants/${loggedInUser.TenantId}/projects`;

    const fetchProjects = async (params) => {
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setProjects(response.data.list);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    const search = async (name) => {
        const newSearchParams = {name};
        await fetchProjects(newSearchParams);
    };

    const handleCreate = () => {
        setEditingProject(null);
        setShowCreateEditModal(true);
    };

    const handleEdit = (project) => {
        setEditingProject(project);
        setShowCreateEditModal(true);
    };

    const handleAssignPhoneNumber = (project) => {
        setAssigningPhoneNumberProject(project);
        setShowAssignPhoneNumberModal(true);
    };

    const handleDelete = async (id) => {
        const url = `${baseUrl}/${id}`;

        try {
            await apiClient.delete(url);
            await fetchProjects();
        } catch (error) {
            console.error('Error deleting project:', error);
        }
    };

    const handleCloseCreateEditModal = () => {
        setShowCreateEditModal(false);
    };

    const handleCloseAssignPhoneNumberModal = () => {
        setShowAssignPhoneNumberModal(false);
    };

    const handleSubmitCreateEditModal = async (projectData) => {
        const url = editingProject ? `${baseUrl}/${editingProject.id}` : baseUrl;

        try {
            if (editingProject) {
                await apiClient.patch(url, projectData);
                toast.success('Project updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, projectData);
                toast.success('Project created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowCreateEditModal(false);
            await fetchProjects();
        } catch (error) {
            console.error('Error saving project:', error);
        }
    };

    const handleSubmitAssignPhoneNumberModal = async (phoneNumbers) => {
        try {
            const url = `${baseUrl}/${assigningPhoneNumberProject.id}/phones`;
            await apiClient.patch(url, {phoneNumbers});
            setShowAssignPhoneNumberModal(false);
            await fetchProjects();
        } catch (error) {
            console.error('Error adding phone numbers:', error);
        }
    };

    return (
        <div className="mainBody">
            <ProjectSearch onSearch={search} onCreate={handleCreate}/>
            <ProjectTable projects={projects} onEdit={handleEdit} onAssignPhoneNumber={handleAssignPhoneNumber}
                          onDelete={handleDelete}/>

            {showCreateEditModal &&
                <ProjectCreate project={editingProject} onClose={handleCloseCreateEditModal}
                               onSubmit={handleSubmitCreateEditModal}/>}

            {showAssignPhoneNumberModal &&
                <AssignPhoneNumbers project={assigningPhoneNumberProject} onClose={handleCloseAssignPhoneNumberModal}
                                    onSubmit={handleSubmitAssignPhoneNumberModal}/>}
        </div>
    );
}

export default Projects;
